<template>
  <div class="infinite-list-wrapper home" v-loading="vloading">
    <!-- bannar+标语 -->
    <div class="bannar">
      <img src="../../public/img/bannar_news.jpg" />
      <div class="bigtitle">
        <p class="bannerdes1">新闻资讯</p>
        <p class="bannerdes2">News and information</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">通过媒体，了解我们更多</p>
      </div>
    </div>
    <div :class="tabStyle == 1 ? 'tap' : 'tap newsmTab2 tabMove'">
      <div
        v-for="item in tabData"
        @click="tableclick"
        :key="item.id"
        :class="
          active == item.id || keyPath == 5 + '-' + item.id
            ? 'active tapItem'
            : 'tapItem'
        "
      >
        <div>{{ item.dictValue }}</div>
      </div>
    </div>
    <div class="model model2">
      <div class="detail_floor1">
        <div class="detail_title">{{ data.title }}</div>
        <div class="detail_time">发布时间：{{ data.uploadTime }}</div>
      </div>
      <!-- 如果是视频有这个格式 -->
      <div
        class="detail_floor2"
        v-if="activeName == 'item0'"
        @click="openVideo(data.coverImg)"
      >
        <video class="video_url" :src="data.coverImg" poster=""></video>
        <img
          src="../../public/img/home/play.png"
          alt=""
          class="btn_playVideo"
        />
      </div>

      <div
        class="detail_floor3 vhtml"
        style="white-space: pre-wrap"
        v-html="data.context"
      ></div>
    </div>
    <!-- 视频弹框 -->
    <el-dialog
      title="视频"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="closeVideo"
    >
      <video :src="videoUrl" class="mineVideo" controls id="video"></video>
    </el-dialog>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import { getFunc } from "@/api/home";
import { postPv } from "@/api/postPv";

// @ is an alias to /src
export default {
  name: "newsdetail",
  data() {
    return {
      videoUrl: "",
      vloading: true, //
      dialogVisible: false, //视频界面
      activeName: "item0", //具体数据视频还是普通在巡
      titleArr: [
        { id: 1, title1: "视频新闻", title2: "Video News" },
        { id: 2, title1: "企业资讯", title2: "Corporate news" },
      ],
      data: [], //新闻详情数据
      tabData: [],
      keyPath: "",
    };
  },
  watch: {},
  computed: {},
  inject: ["reload"],
  methods: {
    tableclick(tab) {
      //锚点跳转
      this.$router.push({ path: "/news", query: {} });
      window.scroll(0, 0);
      this.$forceUpdate();
    },
    unesacpeHTML(a) {
      a = "" + a;
      return a
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&nbsp;/g, " ");
    },
    closeVideo() {
      this.dialogVisible = false;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.pause();
      });
    },
    openVideo(url) {
      //打开视频
      let that = this;
      //console.log(url);
      this.videoUrl = url;
      this.dialogVisible = true;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.play();
      });
    },
    getDict() {
      postPv(
        "https://www.azureflying.com/api/blade-system/dict-biz/child-list?current=1&size=10&parentId=1"
      )
        .then((res) => {
          let result = res.data;
          // let arr = result.filter((item) => {
          //   return item.key == "1";
          // });
          this.tabData = result;
        })
        .catch((err) => {});
    },
    onLoad(id) {
      let thiz = this;
      let url = "/blade-website/web/menu/article/detail"; //企业资讯
      //如果没有更多 返回不加载了
      let url2 = "/blade-website/web/index/readNum";
      getFunc(url, { id: id })
        .then((res) => {
          if (res.code == 200) {
            const data2 = res.data;
            thiz.data = data2;
            thiz.data.context = thiz.unesacpeHTML(thiz.data.context);
            if (data2.classifyId == "2") {
              thiz.activeName = "item1"; //资讯
            } else {
              thiz.activeName = "item0"; //视频
            }
            thiz.vloading = false;
          }
        })
        .catch((err) => {
          thiz.vloading = false;
        });
      getFunc(url2, { id: id, type: 2 }).then((res) => {
        //console.log(res);
      });
    },
  },
  mounted() {
    let thiz = this;
    this.getDict();
    thiz.$nextTick(() => {
      //企业资讯
      let id = thiz.$route.query.id;
      this.keyPath = this.$route.query.keyPath;

      //console.log(id);
      thiz.onLoad(id);
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
  },
  components: { Minetitle2 },
};
</script>
<style scoped>
.tap {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  width: 100%;
  border-bottom: 1px solid #999999;
  padding-left: 360px;
  box-shadow: 0px 0px 5px 4px #99999982;
}
.tap .tapItem {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  position: relative;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tap .tapItem.active {
  color: #589ef8;
  border-bottom: 2px solid #589ef8;
}
.tap .tapItem:hover {
  border-bottom: 2px solid #589ef8;
  background: rgba(0, 0, 0, 0.1);
}
.tap .tapItem:hover .tapItemChildren {
  opacity: 1;
  transition: all 0.5s;
}
.tap .tapItem .tapItemChildren {
  position: absolute;
  background: white;
  top: 65px;
  width: 100%;
  left: 0;
  opacity: 0;
  transition: all 0.5s;
  z-index: 99;
}
.tap .tapItem .tapItemChildren .tapItemChildrenItem {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
  width: 100%;
}
.tap .tapItem .tapItemChildren .tapItemChildrenItem:hover {
  background: rgba(0, 0, 0, 0.1);
}
.tap .tapItem .tapItemChildrenItem.active {
  color: #589ef8;
}
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
  background: #f7f7f7;
  height: 99%;
  overflow: auto;
}
.bannar {
  width: 100%;
  height: 673px;
  position: relative;
}
.bannar img {
  width: 100%;
  height: 100%;
}
.bigtitle {
  width: 680px;
  position: absolute;
  left: 320px;
  top: 130px;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  line-height: 72px;
  margin-bottom: 48px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 79px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin-bottom: 21px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  line-height: 60px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  letter-spacing: 5px;
}

/* 小导航栏 */

.model {
  width: 88%;
  max-width: 1702px;
  margin: 0 auto;
  position: relative;
  margin-top: 50px;
}
.model2title {
  padding-left: 200px;
}
.video_all {
  width: 75%;
  margin: 0 auto 76px;
  height: 810px;
  overflow: hidden;
}
.video_item {
  /* width: 1045px; */
  height: 100%;
}
.video_floor1 {
  /* width: 1038px;*/
  height: 719px;
  border: 1px solid #589ef8;
  box-shadow: -1px 1px 9px 1px rgba(17, 126, 185, 0.68);
  margin-bottom: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.video_url {
  width: 98%;
  height: 98%;
  background: #383838;
  object-fit: fill;
  position: absolute;
  left: 1%;
  top: 1%;
}
.btn_playVideo {
  width: 151px;
  height: 151px;
  position: relative;
  z-index: 25;
}
.video_floor2 {
  width: 100%;
  height: 32px;
}
.video_name {
  height: 32px;
  line-height: 32px;
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  float: left;
}
.video_time {
  float: right;
  height: 32px;
  line-height: 32px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}

.smTab {
  margin-bottom: 77px;
}
.model2 {
  width: 70%;
  max-width: 1280px;
  margin-bottom: 61px;
}
.detail_floor1 {
  width: 100%;
  height: auto;
  border-bottom: 1px solid #dddddd;
}
.detail_title {
  width: 100%;
  text-align: center;
  height: auto;
  line-height: 1.35;
  font-size: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 15px;
}
.detail_time {
  width: 100%;
  text-align: center;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  margin-bottom: 39px;
}
/* 详情的样式 */
.detail_floor1 {
  margin-bottom: 61px;
}
.detail_floor3 p,
.detail_floor3 span {
  font-size: 24px !important;
}
/* 视频 */
.detail_floor2 {
  width: 100%;
  height: 960px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
}
.video_url {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.btn_playVideo {
  width: 151px;
  height: 151px;
  position: relative;
  z-index: 2;
}
.mineVideo {
  width: 100%;
  height: 600px;
}
</style>
